import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';

import { Button } from 'web-ui-components/lib/atoms/buttons';

import withContent from '../../containers/withContent';

import pageContent, { contentPropTypes } from './Notifications.content';
import { editPaymentTemplate } from '../../states/templates/actions';
import { clearNotification } from '../../states/notifications/actions';

const mapDispatch = (dispatch) => ({
	editTemplate: (id) => dispatch(editPaymentTemplate(id)),
	handleClear: (id) => dispatch(clearNotification(id)),
});

const EditTemplateButton = ({ editTemplate, templateId, content, notificationId, handleClear }) => (
	<span>
		{content.editTemplateText}
		<Button
			onClick={() => {
				handleClear(notificationId);
				editTemplate(templateId);
			}}
			role="button"
		>
			<span className="c-a-button__title">{content.editTemplateButtonText}</span>
		</Button>
	</span>
);

EditTemplateButton.propTypes = {
	editTemplate: PropTypes.func,
	templateId: PropTypes.string,
	content: PropTypes.shape(contentPropTypes),
	notificationId: PropTypes.number,
	handleClear: PropTypes.func,
};

export default compose(connect(null, mapDispatch), withContent({ content: pageContent }))(EditTemplateButton);
